import { render } from "./Mainselect.vue?vue&type=template&id=5f92b4de&scoped=true"
import script from "./Mainselect.vue?vue&type=script&lang=js"
export * from "./Mainselect.vue?vue&type=script&lang=js"

import "./Mainselect.vue?vue&type=style&index=0&id=5f92b4de&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f92b4de"]])

export default __exports__